export default "__VITE_ASSET__CrK53STG__"